<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="sponsors"
    [viewName]="title"
    [record]="sponsorRecord"
    [fields]="fields"
>
</dynamic-view-v2>
